/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WindowSize } from '../WindowSize.js';
import { useNavigate } from 'react-router-dom';
import { GetUrl, CTicksToDateString, formatNumber } from '../Utility.js';

import Title from './Title.js';
import DetailModalType3 from './DetailModalType3.js'

function QAWait() {
  const state=useSelector((state)=>state);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 

  const [pageIndex, setpageIndex] = useState(0); // 선택된 드롭다운 항목
  const [totalCount, setTotalCount] = useState(0); // 선택된 드롭다운 항목
  const [viewIndex, setviewIndex] = useState(0); // 선택된 드롭다운 항목


    function Reset()
    {
        setpageIndex(0);
        setTotalCount(0);
        setviewIndex(1);
        RequestQASearch(1);
    }

  function GetPageNumber(number)
  {
    return (pageIndex * 10) + number;
  }

  function NextPage()
  {
    if(totalCount === 0)
    {
        return;
    }

    var maxIndex = Math.ceil(totalCount / 15);
    if(viewIndex === maxIndex)
    {
        return;
    }

    var newViewIndex = viewIndex + 1;
    ClickViewIndex(newViewIndex);  
    setpageIndex(Math.floor((newViewIndex - 1) / 15));
  }

  function PrevPage()
  {
    if(totalCount === 0 ||
        viewIndex === 1)
    {
        return;
    }

    var newViewIndex = viewIndex - 1;
    ClickViewIndex(newViewIndex);
    setpageIndex(Math.floor((newViewIndex - 1) / 15));
  }

  function ClickViewIndex(index)
  {
    if(totalCount === 0)
    {
        return;
    }
    
    if(state.Request === 1)
    {
        return;
    }
    
    if(viewIndex === index)
    {
        return;
    }

    var maxIndex = Math.ceil(totalCount / 15);
    if(maxIndex < index)
    {
        return;
    }

    setviewIndex(index);
    RequestQASearch(index);
  }

    const RequestQASearch = async (index) => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            }
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Admin/AdminQAWait', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, start_index : index - 1, content_count : 15}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    dispatch({type:'UpdateQAWaitArray', Log:data.data_array});  
                    setTotalCount(data.total_count);
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                    var startTime = CTicksToDateString(data.start_time);
                    var endTime = CTicksToDateString(data.end_time);

                    var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                    alert(message);  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };

    function GetQANo(index)
    {
        if(state.QAWaitArray === undefined || state.QAWaitArray.length <= index)
        {
            return "";
        }

        var convertIndex = ((viewIndex - 1) * 10) + index;
        if(totalCount <= convertIndex)
        {
            return'';
        }

        return convertIndex + 1;
    }

    function GetQAID(index)
    {
        if(state.QAWaitArray === undefined || state.QAWaitArray.length <= index)
        {
            return "";
        }

        return state.QAWaitArray[index].id;
    }

    function GetQATitle(index)
    {
        if(state.QAWaitArray === undefined || state.QAWaitArray.length <= index)
        {
            return "";
        }

        return state.QAWaitArray[index].title;
    }

    function GetQARegisterTime(index)
    {
        if(state.QAWaitArray === undefined || state.QAWaitArray.length <= index)
        {
            return "";
        }

        return CTicksToDateString(state.QAWaitArray[index].create_at_time);
    }

    function GetQAClick(index)
    {
        if(state.QAWaitArray === undefined || state.QAWaitArray.length <= index)
        {
            return false;
        }

        return true;
    }

    function QAClick(index)
    {
        if(state.QAWaitArray === undefined || state.QAWaitArray.length <= index)
        {
            return;
        }

        dispatch({type:'UpdateDetailModalType3', View:true, No:state.QAWaitArray[index].no});
    }

  const closeDetailModalType3 = (refresh) => {
    dispatch({type:'UpdateDetailModalType3', View:false, No:0});
    if(refresh === true)
    {
        dispatch({type:'RefreshQAWait', Refresh:false});
        Reset();
    }
  }

  if(state.QAWaitFirstRender === false)
    {
        dispatch({type:'QAWaitFirstRender'});
        Reset();
    }

  return (
    <div id='Player_Range'>
        <Title DisplayType="4"></Title>
        <div className='qa-wait-box'>
            <div className='qa-wait-box-table'>
                <tr>
                    <th style={{width:"5%"}}>넘버</th>
                    <th style={{width:"5%"}}>작성자</th>
                    <th style={{width:"10%"}}>제목</th>
                    <th style={{width:"10%"}}>작성일</th>
                </tr>
                {Array.from({length:15}).map((_, index)=>(
                    <tr>
                        <td onClick={() => GetQAClick(index) === true && QAClick(index)} style={{cursor: GetQAClick(index) === true ? 'pointer' : 'default', width:"200px", textAlign:"center"}}>{GetQANo(index)}</td>
                        <td onClick={() => GetQAClick(index) === true && QAClick(index)} style={{cursor: GetQAClick(index) === true ? 'pointer' : 'default', width:"600px", textAlign:"center"}}>{GetQAID(index)}</td>
                        <td onClick={() => GetQAClick(index) === true && QAClick(index)} style={{cursor: GetQAClick(index) === true ? 'pointer' : 'default', width:"600px", textAlign:"center"}}>{GetQATitle(index)}</td>
                        <td onClick={() => GetQAClick(index) === true && QAClick(index)} style={{cursor: GetQAClick(index) === true ? 'pointer' : 'default', width:"300px", textAlign:"center"}}>{GetQARegisterTime(index)}</td>
                    </tr>
                ))}
            </div>
            <div className='qa-wait-box-count-box'>
                <div className='qa-wait-box-count' onClick={() => PrevPage()}><h2>{"<"}이전</h2></div>
                <div className='qa-wait-box-count' onClick={() => ClickViewIndex(GetPageNumber(1))}><h2>{GetPageNumber(1)}</h2></div>
                <div className='qa-wait-box-count' onClick={() => ClickViewIndex(GetPageNumber(2))}><h2>{GetPageNumber(2)}</h2></div>
                <div className='qa-wait-box-count' onClick={() => ClickViewIndex(GetPageNumber(3))}><h2>{GetPageNumber(3)}</h2></div>
                <div className='qa-wait-box-count' onClick={() => ClickViewIndex(GetPageNumber(4))}><h2>{GetPageNumber(4)}</h2></div>
                <div className='qa-wait-box-count' onClick={() => ClickViewIndex(GetPageNumber(5))}><h2>{GetPageNumber(5)}</h2></div>
                <div className='qa-wait-box-count' onClick={() => ClickViewIndex(GetPageNumber(6))}><h2>{GetPageNumber(6)}</h2></div>
                <div className='qa-wait-box-count' onClick={() => ClickViewIndex(GetPageNumber(7))}><h2>{GetPageNumber(7)}</h2></div>
                <div className='qa-wait-box-count' onClick={() => ClickViewIndex(GetPageNumber(8))}><h2>{GetPageNumber(8)}</h2></div>
                <div className='qa-wait-box-count' onClick={() => ClickViewIndex(GetPageNumber(9))}><h2>{GetPageNumber(9)}</h2></div>
                <div className='qa-wait-box-count' onClick={() => ClickViewIndex(GetPageNumber(10))}><h2>{GetPageNumber(10)}</h2></div>
                <div className='qa-wait-box-count' onClick={() => NextPage()}><h2>다음{">"}</h2></div>
            </div>
        </div>
        <DetailModalType3 isOpen={state.detail_modal_type3_open} No={state.detail_modal_type3_no} onClose={closeDetailModalType3} ></DetailModalType3>
    </div>
  );
}

export default QAWait;